module.exports = __webpack_public_path__ + "img/video_placeholder.9a5992ff.jpg";